var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.304268 4.05451C0.673353 4.4236 1.25955 4.45978 1.65758 4.12688C5.03724 1.34788 9.94391 1.34788 13.3308 4.11964C13.7361 4.45254 14.3295 4.4236 14.6986 4.05451C15.1256 3.62753 15.0966 2.91831 14.6262 2.53475C10.4939 -0.844916 4.51618 -0.844916 0.376638 2.53475C-0.0937648 2.91107 -0.12995 3.62029 0.304268 4.05451ZM5.92015 9.67039L6.98399 10.7342C7.26623 11.0165 7.72216 11.0165 8.0044 10.7342L9.06823 9.67039C9.40837 9.33026 9.336 8.74406 8.90178 8.51972C8.01887 8.06379 6.96228 8.06379 6.07213 8.51972C5.65962 8.74406 5.58002 9.33026 5.92015 9.67039ZM3.22077 6.97101C3.57538 7.32562 4.13262 7.3618 4.54513 7.06509C6.31095 5.81309 8.68468 5.81309 10.4505 7.06509C10.863 7.35457 11.4202 7.32562 11.7749 6.97101L11.7821 6.96377C12.2163 6.52955 12.1874 5.79138 11.688 5.43677C9.1985 3.63477 5.80436 3.63477 3.30761 5.43677C2.80826 5.79862 2.77931 6.52955 3.22077 6.97101Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiSmall);
export default __webpack_public_path__ + "static/media/Wifi_Small.c94e60bf692923a04c81e41e4394e5c5.svg";
export { ForwardRef as ReactComponent };